import { useState, useEffect } from "react";

import { api } from "@/services/api";
import { useHistory } from "react-router-dom";

export default function useAuth() {
	let history = useHistory();
	const [authenticated, setAuthenticated] = useState(false);
	const [type, setType] = useState(null);
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		const passport = localStorage.getItem("@geriox-passport");
		const type = localStorage.getItem("@type");
		const { expires_in } = passport ? JSON.parse(passport) : false;
		const dataNow = new Date().getTime();

		if (passport && type) {
			let { token } = JSON.parse(passport);

			api.defaults.headers.Authorization = `Bearer ${token}`;
			setAuthenticated(true);
			setType(type);
			history.push(`${process.env.PUBLIC_URL}/home/${type}`);
		}

		if (
			expires_in &&
			!(expires_in && new Date(expires_in).getTime() > dataNow)
		) {
			handleLogout(`${process.env.PUBLIC_URL}`);
		}

		setLoading(false);
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	async function handleLogin(notify, type, token, user = {}) {
		const tokenAcess = token;

		localStorage.setItem("@geriox-passport", JSON.stringify(tokenAcess));
		localStorage.setItem("@type", type);
		localStorage.setItem("@profile", JSON.stringify(user));
		localStorage.setItem("@notification-active", notify);

		api.defaults.headers.Authorization = `Bearer ${tokenAcess.token}`;
		setAuthenticated(true);
		history.push(`${process.env.PUBLIC_URL}/home/${type}`);
	}

	function handleLogout(route) {
		setAuthenticated(false);
		setType(null);
		localStorage.removeItem("@geriox-passport");
		localStorage.removeItem("@type");
		localStorage.removeItem("@profile");
		localStorage.removeItem("@notification-active");
		api.defaults.headers.Authorization = undefined;
		history.push(route);
	}

	return { authenticated, type, loading, handleLogin, handleLogout };
}
